import React from "react";
import { connect } from "react-redux";
import { Col, Row } from "react-bootstrap";
import CardComponent from "./ComputersCard/Card";
import "./Computer.css";
import InfiniteScroll from "react-infinite-scroll-component";
import Spinner from "../Loader/Loader";

const ComputerView = ({
    computers,
    onShowAddModel,
    getComputerDetailView,
    editComputer,
    deleteComputer,
    getnextComputers,
    hasmore,
    isAdmin
}) => {

    return (
        <InfiniteScroll
            dataLength={computers.length}
            next={getnextComputers}
            style={{ overflowX: "hidden" }}
            hasMore={hasmore}
            loader={
                <h4 style={{ textAlign: "center" }}>
                    <Spinner />
                </h4>
            }
            endMessage={
                <p style={{ textAlign: "center" }}>
                    {computers.length !== 0 ? (
                        <>
                            {computers.length > 5 && (
                                <span>No more computers found</span>
                            )}
                        </>
                    ) : (
                        <b>No Computers Found</b>
                    )}
                </p>
            }
        >

            {/* ================================
                COMPUTER CARD GRID
            ================================= */}

            <Row className="g-4">

                {computers.map((computer, idx) => (

                    <Col
                        key={computer.ComputerID || idx}
                        xs={12}
                        sm={6}
                        md={4}
                        lg={3}
                    >

                        <CardComponent
                            s_no={idx + 1}
                            ComputerName={computer.ComputerName}
                            ComputerId={computer.ComputerID}
                            OS={computer.OS}
                            Username={computer.Username}
                            SystemType={computer.SystemType}
                            licenseType={computer.licenseType}
                            Status={computer.Status}
                            getComputerDetailView={getComputerDetailView}
                            computer={computer}
                            editComputer={editComputer}
                            deleteComputer={deleteComputer}
                            isAdmin={isAdmin}
                        />

                    </Col>

                ))}

            </Row>

        </InfiniteScroll>
    );
};

const mapStateToProps = (state) => {
    return {};
};

export default connect(mapStateToProps, null)(ComputerView);